import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import ru from './locales/ru.json';
import uk from './locales/uk.json';

export type AppLocale = 'en' | 'ru' | 'uk';

const STORAGE_KEY_EMBED = 'idea-calc-locale';
const STORAGE_KEY_STANDALONE = 'idea-calc-locale-standalone';
const SUPPORTED: AppLocale[] = ['en', 'ru', 'uk'];

const IS_IN_IFRAME = typeof window !== 'undefined' && window.self !== window.top;

function getStorageKey(): string {
  return IS_IN_IFRAME ? STORAGE_KEY_EMBED : STORAGE_KEY_STANDALONE;
}

function detectInitialLocale(): AppLocale {
  try {
    const stored = localStorage.getItem(getStorageKey());
    if (stored && (SUPPORTED as string[]).includes(stored)) return stored as AppLocale;
  } catch (_) {
    /* localStorage недоступен — используем дефолт */
  }
  return 'ru';
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ru: { translation: ru },
      uk: { translation: uk },
    },
    lng: detectInitialLocale(),
    fallbackLng: 'en',
    // Локали писались с одинарными скобками ({count}, {qty}) — переключаем
    // interpolation с дефолтных {{...}} на {...}, иначе плейсхолдеры выводятся буквально.
    interpolation: { escapeValue: false, prefix: '{', suffix: '}' },
    react: { useSuspense: false },
  });

export function setLocale(locale: string): void {
  if (!(SUPPORTED as string[]).includes(locale)) return;
  i18n.changeLanguage(locale);
  try {
    localStorage.setItem(getStorageKey(), locale);
  } catch (_) {
    /* localStorage недоступен — молча игнорируем */
  }
}

export default i18n;
